export const SimplifiedLeftMenuItems = [
	'overview',
	'pdfreview',
	'photoreview',
	'helpcenter'
];
